var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-new": _vm.isCanAdd,
              "show-print": _vm.isCanPrint,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("orm-batching-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "tile is-parent" }, [
                _c(
                  "article",
                  { staticClass: "tile is-child box" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.entities, function (batch, index) {
                          return _c(
                            "tr",
                            {
                              key: batch.batchNo,
                              class: {
                                "is-selected": _vm.selectedRow === index,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c("td", [
                                _vm.isCanRead
                                  ? _c(
                                      "div",
                                      {
                                        class: {
                                          "is-flex is-align-items-center is-justify-content-space-between":
                                            _vm.completedStatus.includes(
                                              batch.batchStatus
                                            ),
                                        },
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                path: `/ormbatching/batch/${batch.batchId}`,
                                              },
                                              append: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(batch.batchNo) + " "
                                            ),
                                          ]
                                        ),
                                        _vm.completedStatus.includes(
                                          batch.batchStatus
                                        )
                                          ? _c("i", {
                                              staticClass:
                                                "mdi mdi-lock-outline mdi-20px has-text-danger",
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _c("span", [_vm._v(_vm._s(batch.batchNo))]),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatBatchStatus(
                                      batch.batchStatus
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "has-text-right",
                                  class: {
                                    "has-text-danger":
                                      batch.count < batch.minBatchSize,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(batch.count) +
                                      "/" +
                                      _vm._s(batch.minBatchSize)
                                  ),
                                ]
                              ),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateLocale(
                                      batch.batchDate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      batch.agreedArc,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumberWithRounding(
                                      batch.averageLabourUnit,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      batch.averageLabourValue,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.$filters.formatNumberWithRoundUp(
                                        batch.averageLabourRate,
                                        _vm.$userInfo.locale,
                                        1
                                      ),
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      batch.averageRepairCost,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "has-text-right",
                                  class: {
                                    "has-text-danger": _vm.delta(batch) < 0,
                                    "has-text-success": _vm.delta(batch) >= 0,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.delta(batch),
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm.isCanRead
                                ? _c(
                                    "td",
                                    { staticClass: "has-text-centered" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              path: `/ormbatching/batch/${batch.batchId}`,
                                            },
                                            append: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "button is-primary is-small is-inverted tooltip",
                                              attrs: {
                                                "data-tooltip": "Click to edit",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "icon is-medium",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "mdi mdi-lead-pencil mdi-24px",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("orm-batching-new-modal", {
            attrs: { active: _vm.isNewBatchModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isNewBatchModalActive = $event
              },
              close: _vm.closeNewBatchModal,
              add: _vm.handleAddNewBatch,
            },
            model: {
              value: _vm.entity,
              callback: function ($$v) {
                _vm.entity = $$v
              },
              expression: "entity",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }